import { Button, SVG } from "ui";
import {
    CustomComponentProps,
    GeneralModalProps
} from "utils/types/generalTypes";

export type ClearActivityModalProps = GeneralModalProps & CustomComponentProps;

const ClearActivityModal = ({
    open,
    setOpen,
    className,
    style
}: ClearActivityModalProps) => {
    return (
        <div
            className={`incdident-rules-modal modal share-modal is-xsmall has-light-bg ${open ? "is-active" : ""} ${className}`}
            style={style}
        >
            <div
                className="modal-background"
                onClick={() => setOpen(false)}
            ></div>
            <div className="modal-content">
                <div className="card">
                    <div className="card-heading flex-a-center flex-j-center flex-col gap-10">
                        <div className="blue-large-circle">
                            <SVG
                                svg="exclamation2"
                                size={30}
                                className="white-svg cursor-default"
                            />
                        </div>
                        <h3 className="fw-700 fs-100">
                            Are you sure you want to clear your activity?
                        </h3>
                    </div>
                    <div className="card-footer" style={{ background: "none" }}>
                        <div className="button-wrap d-flex flex-j-between  w-full">
                            <Button
                                text="NO"
                                handleClick={() => setOpen(false)}
                                style={{ width: "47%" }}
                            />
                            <Button
                                text="Yes"
                                handleClick={() => setOpen(false)}
                                style={{ width: "47%" }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ClearActivityModal;
